import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

export const StyledJobEditorSection = styled.div<{ isUnderlined?: boolean }>`
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin: 24px 32px 32px;
    padding-bottom: 32px;

    border-bottom: ${({ isUnderlined = true }) => (isUnderlined ? `1px solid ${colorsPalettes.carbon[100]}` : "none")};
`;
